import { useUserEventLogger } from '@repo/tracking-service';
import { BoxButton, IndeterminateProgress, useToast } from '@repo/ui';
import { useState } from 'react';
import { graphql, useMutation } from 'react-relay';

import { RefundAvailabilityAlarmButtonMutation } from '@/__generated__/RefundAvailabilityAlarmButtonMutation.graphql';
import { useLookupResultRefundData } from '@/components/tax-refund/lookup/result/LookupResultContext';

const refundAvailabilityAlarmButton = graphql`
  mutation RefundAvailabilityAlarmButtonMutation($refundId: String!) {
    applyRefundPossibleAlarm(refundId: $refundId) {
      result
    }
  }
`;

export const RefundAvailabilityAlarmButton = () => {
  const [commit, isInFlight] = useMutation<RefundAvailabilityAlarmButtonMutation>(refundAvailabilityAlarmButton);
  const [isCompleteAlarm, setIsCompleteAlarm] = useState(false);
  const { toast } = useToast();
  const { refundId, refundAmount } = useLookupResultRefundData();
  const { pageName, sendClickEvent } = useUserEventLogger();

  const handleClick = () => {
    sendClickEvent(`${pageName}_result_notice`, { amount: refundAmount });
    commit({
      variables: {
        refundId: refundId ?? ''
      },
      onCompleted: (response, errors) => {
        if (errors) {
          if (errors.length > 0) {
            toast({ title: errors[0]?.message, variant: 'warning' });
          }
          return;
        }

        if (response.applyRefundPossibleAlarm.result) {
          setIsCompleteAlarm(true);
          toast({ title: '알림 신청이 완료되었습니다.', variant: 'success' });
        } else {
          toast({ title: '알 수 없는 문제가 발생하였습니다.', variant: 'warning' });
        }
      },
      onError: (error: Error) => {
        console.log(error);
        toast({ title: '알 수 없는 문제가 발생하였습니다.', variant: 'warning' });
      }
    });
  };

  return (
    <BoxButton variant={'tonal-primary'} size={'medium'} onClick={handleClick} disabled={isCompleteAlarm}>
      {isInFlight ? <IndeterminateProgress /> : <>{isCompleteAlarm ? '알림 신청 완료' : '환급 가능할 때 알림받기'}</>}
    </BoxButton>
  );
};
